import { FormLabel, Grid, InputAdornment, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';
import { NumericFormat } from 'react-number-format';

const getFieldLabel = (field, country) => {
	switch (field) {
		case 'disclosureUrl':
			return 'Public Disclosure Statement';
		case 'fspNumber':
			return `${country === 'AU' ? 'AFS' : 'FSP'} Number`;
		case 'claimsEmail':
			return 'Claims email';
		case 'contactEmail':
			return 'Contact email';
		case 'termsOfEngagement':
			return 'Terms of Engagement';
		case 'privacyStatement':
			return 'Privacy Statement';
		default:
			return field
				.replace(/([a-z])([A-Z])/g, '$1 $2')
				.replace(/(^\w|\s\w)/g, (c) => c.toUpperCase());
	}
};

const BrokerageFormField = ({ field, canEdit = true }) => {
	const { values, setFieldValue, getFieldProps, touched, errors } = useFormikContext();
	const fieldProps = getFieldProps(field);
	const disabled = !canEdit;
	const country = values.country;

	return (
		<Grid size={field === 'about' ? 12 : 6} key={field}>
			<FormLabel>{getFieldLabel(field, country)}</FormLabel>
			{field === 'fspNumber' ? (
				<NumericFormat
					customInput={TextField}
					decimalScale={0}
					fixedDecimalScale
					allowNegative={false}
					allowLeadingZeros
					fullWidth
					disabled={disabled}
					onValueChange={({ value }) => {
						setFieldValue('fspNumber', value);
					}}
					{...fieldProps}
					error={touched.fspNumber && Boolean(errors.fspNumber)}
					helperText={touched.fspNumber && errors.fspNumber}
					slotProps={{
						input: {
							sx: {
								'& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
									{
										WebkitAppearance: 'none',
										margin: 0,
									},
							},
							startAdornment: (
								<InputAdornment position='start'>
									{country === 'AU' ? 'AFS' : 'FSP'}
								</InputAdornment>
							),
						},
					}}
				/>
			) : field === 'phoneNumber' ? (
				<NumericFormat
					customInput={TextField}
					decimalScale={0}
					fixedDecimalScale
					allowNegative={false}
					allowLeadingZeros
					fullWidth
					disabled={disabled}
					onValueChange={({ value }) => {
						setFieldValue('phoneNumber', value);
					}}
					{...fieldProps}
					error={touched.phoneNumber && Boolean(errors.phoneNumber)}
					helperText={touched.phoneNumber && errors.phoneNumber}
					slotProps={{
						input: {
							sx: {
								'& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
									{
										WebkitAppearance: 'none',
										margin: 0,
									},
							},
						},
					}}
				/>
			) : (
				<TextField
					fullWidth
					multiline={field === 'about'}
					rows={field === 'about' ? 4 : 1}
					disabled={disabled}
					{...fieldProps}
				/>
			)}
		</Grid>
	);
};

export default BrokerageFormField;
